export default __webpack_public_path__ + "static/media/macos-wallpaper-dark.5069e512.webp";